@if (productShortcuts$ | async; as productShortcuts) {
  @if (hasVisibleEntries(productShortcuts)) {
    <ul>
      @for (shortcut of productShortcuts.shortcuts; track shortcut) {
        @if (shortcut.visible) {
          <li class="shotcut">
            <button class="btn btn-outline-secondary btn-sm" (click)="scrollToSection(shortcut.targetUID)">
              @if (shortcut.icon) {
                <span class="material-symbols-outlined d-flex m-r-4"> {{ shortcut.icon }} </span>
              }
              {{ shortcut.label }}
            </button>
          </li>
        }
      }
    </ul>
  }
}
